import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';

const PriceSectionSkeleton = () => {
  return (
    <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
      <Stack spacing={0.5} alignItems="center">
        <Skeleton variant="text" width={60} height={20} />
        <Skeleton variant="text" width={80} height={28} />
      </Stack>
      <Stack spacing={0.5} alignItems="center">
        <Skeleton variant="text" width={50} height={20} />
        <Skeleton variant="text" width={70} height={28} />
      </Stack>
    </Box>
  );
};

export default PriceSectionSkeleton;
